<script setup>
const entriesStore = useEntriesStore();

async function gotoHome() {
  await navigateTo("/");
  entriesStore.setCurrent(null);
}
</script>

<template>
  <button @click="gotoHome" class="logo block w-[200px] lg:w-[190px]">
    <img src="/img/logo.svg" class="w-full h-auto max-w-full" />
  </button>
</template>

<style></style>
